import samlService              from '@/auth/saml.service'
import { isDefined, stringify } from '@/common/utils'
import Vue                      from 'vue'

const KEYS = {
  KEYCLOAK_TOKEN: 'keycloak.token',
  SAML_TOKEN    : 'saml.token',
  USER_INFO     : 'current.user',
}

class AuthStore {

  constructor () {
    this.$keycloakToken = null
    this.$samlToken     = null
    this.$user          = null
    this.$rcwId         = null
  }

  get keycloakToken () {
    this.$keycloakToken = this.$keycloakToken || localStorage.getItem(KEYS.KEYCLOAK_TOKEN)
    return this.$keycloakToken
  }

  set keycloakToken (newToken) {
    toLocalStorage(KEYS.KEYCLOAK_TOKEN, newToken)
    this.$keycloakToken = newToken || ''
  }

  get samlToken () {
    this.$samlToken = this.$samlToken || localStorage.getItem(KEYS.SAML_TOKEN)
    return this.$samlToken
  }

  set samlToken (newToken) {
    toLocalStorage(KEYS.SAML_TOKEN, newToken)
    this.$samlToken = newToken || ''
  }

  get user () {
    this.$user = this.$user || fromLocalStorage(KEYS.USER_INFO)
    return this.$user
  }

  set user (user) {
    toLocalStorage(KEYS.USER_INFO, user)
    this.$user = user
  }

  get rcwId () {
    return this.$rcwId
  }

  set rcwId (user) {
    this.$rcwId = user
  }

  resetAll () {
    this.keycloakToken = null
    this.samlToken     = null
    this.user          = null
    this.rcwId         = null
  }

  isAuthenticated () {
    return !!(this.samlToken || this.keycloakToken)
  }

  isRetired () {
    return !!this.keycloakToken
  }

  isEmployee () {
    return !!this.samlToken
  }

  logout () {
    // on recupere isEmployee en utilisant les tokens
    const isEmployee = this.isEmployee()
    // puis on supprime les tokens
    this.resetAll()
    if (isEmployee) {
      // SAML
      samlService.logout()
    } else {
      // KEYCLOAK
      Vue.prototype.$keycloak.logoutFn()
    }
  }

}

const fromLocalStorage = key => {
  const string = localStorage.getItem(key)
  return string ? JSON.parse(string) : undefined
}

const toLocalStorage = (key, value) => {
  if (isDefined(value)) {
    localStorage.setItem(key, stringify(value))
  } else {
    localStorage.removeItem(key)
  }
}

export default new AuthStore()



// WEBPACK FOOTER //
// ./src/auth/auth.store.js